import { render } from "./PaginationLinkComp.vue?vue&type=template&id=e7e3bda6&scoped=true&ts=true"
import script from "./PaginationLinkComp.vue?vue&type=script&lang=ts"
export * from "./PaginationLinkComp.vue?vue&type=script&lang=ts"

import "./PaginationLinkComp.vue?vue&type=style&index=0&id=e7e3bda6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e3bda6"]])

export default __exports__